import { RouteName } from "@/lib/router/routes";
import useAuthStore from "@/stores/useAuthStore";
import { storeToRefs } from "pinia";
import { Router } from "vue-router";

export default function (router: Router) {
  const {
    waitForPlayer,
  } = useAuthStore();

  const {
    isSignedIn,
    currentPlayer,
  } = storeToRefs(useAuthStore());

  router.beforeEach(async (to) => {
    if (isSignedIn.value && ![
      RouteName.onboarding,
      RouteName.onboardingTheme,
      RouteName.onboardingIntro,
      RouteName.onboardingStatuses,
      RouteName.onboardingInvites,
      RouteName.onboardingNotifications,
      RouteName.onboardingProfile,
    ].includes(to.name as RouteName)) {
      await waitForPlayer();

      if (!currentPlayer.value?.theme) {
        const redirect = encodeURIComponent(to.fullPath);

        return {
          name: RouteName.onboarding,
          query: {
            ...to.query,
            redirect,
          },
        };
      }
    }
  });
}
